import React from 'react';
import { ArrowRight, Upload, Camera, BookOpen, Bug } from 'lucide-react';

export default function QuickReplies({ suggestions, onSelectSuggestion }) {
  const getIconForSuggestion = (text, type) => {
    if (type === 'action_button' || text?.toLowerCase()?.includes('upload')) {
      return <Upload className="w-3 h-3" />;
    }
    if (text?.toLowerCase()?.includes('photo') || text?.toLowerCase()?.includes('image')) {
      return <Camera className="w-3 h-3" />;
    }
    if (text?.toLowerCase()?.includes('biological') || text?.toLowerCase()?.includes('beneficial')) {
      return <Bug className="w-3 h-3" />;
    }
    if (text?.toLowerCase()?.includes('learn') || text?.toLowerCase()?.includes('chapter')) {
      return <BookOpen className="w-3 h-3" />;
    }
    return <ArrowRight className="w-3 h-3" />;
  };

  const getSuggestionStyle = (type) => {
    if (type === 'action_button') {
      return 'bg-green-100 border-green-200 text-green-800 hover:bg-green-200';
    }
    return 'bg-gray-100 border-gray-200 text-gray-700 hover:bg-gray-200';
  };

  if (!suggestions || suggestions?.length === 0) {
    return null;
  }

  return (
    <div className="space-y-2">
      <div className="flex items-center gap-2 mb-3">
        <span className="text-xs font-medium text-gray-600">Quick Replies:</span>
        <div className="flex-1 h-px bg-gray-200"></div>
      </div>
      <div className="flex flex-wrap gap-2">
        {suggestions?.map((suggestion, index) => (
          <button
            key={suggestion?.id || index}
            onClick={() => onSelectSuggestion(suggestion?.suggestion_text)}
            className={`flex items-center gap-2 px-3 py-2 rounded-lg border text-sm transition-colors ${getSuggestionStyle(suggestion?.suggestion_type)}`}
          >
            {getIconForSuggestion(suggestion?.suggestion_text, suggestion?.suggestion_type)}
            <span className="truncate max-w-[200px]">{suggestion?.suggestion_text}</span>
          </button>
        ))}
      </div>
      {/* Default IPM Quick Actions */}
      <div className="mt-4 pt-3 border-t border-gray-200">
        <div className="flex items-center gap-2 mb-2">
          <span className="text-xs font-medium text-gray-600">Common IPM Topics:</span>
        </div>
        <div className="flex flex-wrap gap-2">
          <button
            onClick={() => onSelectSuggestion('Help me identify this pest')}
            className="flex items-center gap-2 px-3 py-1.5 rounded-lg bg-blue-50 border border-blue-200 text-blue-700 hover:bg-blue-100 text-xs transition-colors"
          >
            <Bug className="w-3 h-3" />
            Pest ID
          </button>
          <button
            onClick={() => onSelectSuggestion('What biological controls are available?')}
            className="flex items-center gap-2 px-3 py-1.5 rounded-lg bg-green-50 border border-green-200 text-green-700 hover:bg-green-100 text-xs transition-colors"
          >
            <Bug className="w-3 h-3" />
            Biologicals
          </button>
          <button
            onClick={() => onSelectSuggestion('How do I build an IPM program?')}
            className="flex items-center gap-2 px-3 py-1.5 rounded-lg bg-purple-50 border border-purple-200 text-purple-700 hover:bg-purple-100 text-xs transition-colors"
          >
            <BookOpen className="w-3 h-3" />
            IPM Program
          </button>
          <button
            onClick={() => onSelectSuggestion('What are safe application methods?')}
            className="flex items-center gap-2 px-3 py-1.5 rounded-lg bg-orange-50 border border-orange-200 text-orange-700 hover:bg-orange-100 text-xs transition-colors"
          >
            <ArrowRight className="w-3 h-3" />
            Safety
          </button>
        </div>
      </div>
    </div>
  );
}